export default {
    buildMode: 'slot',
    fitnessApiBaseUrl: 'https://fitnessapi.learnbody.co.kr/',
    shopByBaseUrl: 'https://shop-api.e-ncp.com/',
    shopByClientId: 'xRzkr7sOuawIgcDtOgSWSA==',
    marketApiBaseUrl: 'https://marketapi.learnbody.co.kr/',
    marketStorageUrl: 'https://learnbodykr.blob.core.windows.net/diary-images/',
}
